import keyMirror from "keymirror";

const GenerateAdUsersActionNames = keyMirror({
    GENERATE_AD_USERS: null,
    GENERATE_AD_USERS_SUCCESS: null,
    GENERATE_AD_USERS_ERROR: null
});

export default GenerateAdUsersActionNames;
